import { useEffect } from 'react'

interface KeyboardNavigationProps {
  onEscape?: () => void
  onEnter?: () => void
  onArrowUp?: () => void
  onArrowDown?: () => void
  onArrowLeft?: () => void
  onArrowRight?: () => void
  onTab?: () => void
  onShiftTab?: () => void
}

export const KeyboardNavigation = ({
  onEscape,
  onEnter,
  onArrowUp,
  onArrowDown,
  onArrowLeft,
  onArrowRight,
  onTab,
  onShiftTab
}: KeyboardNavigationProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      switch (event.key) {
        case 'Escape':
          if (onEscape) {
            event.preventDefault()
            onEscape()
          }
          break
        case 'Enter':
          if (onEnter && event.target && 
              !['TEXTAREA', 'INPUT'].includes((event.target as HTMLElement).tagName)) {
            event.preventDefault()
            onEnter()
          }
          break
        case 'ArrowUp':
          if (onArrowUp) {
            event.preventDefault()
            onArrowUp()
          }
          break
        case 'ArrowDown':
          if (onArrowDown) {
            event.preventDefault()
            onArrowDown()
          }
          break
        case 'ArrowLeft':
          if (onArrowLeft) {
            event.preventDefault()
            onArrowLeft()
          }
          break
        case 'ArrowRight':
          if (onArrowRight) {
            event.preventDefault()
            onArrowRight()
          }
          break
        case 'Tab':
          if (event.shiftKey && onShiftTab) {
            event.preventDefault()
            onShiftTab()
          } else if (onTab) {
            event.preventDefault()
            onTab()
          }
          break
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [onEscape, onEnter, onArrowUp, onArrowDown, onArrowLeft, onArrowRight, onTab, onShiftTab])

  return null
}

export const useKeyboardShortcuts = () => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Alt + S: Focus settings
      if (event.altKey && event.key === 's') {
        event.preventDefault()
        const settingsButton = document.querySelector('[aria-label="Открыть настройки доступности"]') as HTMLElement
        settingsButton?.focus()
      }
      
      // Alt + M: Focus main content
      if (event.altKey && event.key === 'm') {
        event.preventDefault()
        const mainContent = document.getElementById('main-content')
        mainContent?.focus()
      }
      
      // Alt + 1: Switch to coach tab
      if (event.altKey && event.key === '1') {
        event.preventDefault()
        const coachTab = document.querySelector('[aria-controls="coach-panel"]') as HTMLElement
        coachTab?.click()
      }
      
      // Alt + 2: Switch to education tab
      if (event.altKey && event.key === '2') {
        event.preventDefault()
        const educationTab = document.querySelector('[aria-controls="education-panel"]') as HTMLElement
        educationTab?.click()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])
}